import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import AdminDashboard from './pages/admin/AdminDashboard';
import UserDashboard from './pages/user/UserDashboard';
import CreateDoctor from './pages/admin/CreateDoctor';
import CreateBill from './pages/admin/CreateBill';
import CreateUser from './pages/admin/CreateUser';
import AdminBookingHistory from './pages/admin/BookingHistory';
import BillingReportHistory from './pages/admin/BillingReportHistory';
import UploadLabReport from './pages/admin/UploadLabReport';
import UserProfile from './pages/user/UserProfile';
import ListOfDoctors from './pages/user/ListOfDoctors';
import BookAppointment from './pages/user/BookAppointment';
import UserBookingHistory from './pages/user/BookingHistory';
import UserBillingHistory from './pages/user/BillingHistory';
import LabReportHistory from './pages/user/LabReportHistory';
import Settings from './pages/admin/Settings';
import CreateBooking from './pages/admin/CreateBooking';

function App() {
  return (
    <>
      <style>{`
        body, * { 
          font-family: 'Ubuntu', sans-serif !important; 
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        /* Responsive meta viewport equivalent */
        html {
          font-size: 16px;
        }
        
        /* Mobile-first responsive breakpoints */
        @media (max-width: 768px) {
          html {
            font-size: 14px;
          }
        }
        
        @media (max-width: 480px) {
          html {
            font-size: 12px;
          }
        }
        
        /* Global responsive utilities */
        .mobile-only {
          display: none;
        }
        
        .desktop-only {
          display: block;
        }
        
        @media (max-width: 768px) {
          .mobile-only {
            display: block;
          }
          
          .desktop-only {
            display: none;
          }
        }
        
        /* Touch-friendly button sizes */
        button, .clickable {
          min-height: 44px;
          min-width: 44px;
        }
        
        /* Prevent horizontal scroll on mobile */
        body {
          overflow-x: hidden;
          width: 100%;
        }
      `}</style>
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/user/dashboard" element={<UserDashboard />} />
          <Route path="/admin/create-doctor" element={<CreateDoctor />} />
          <Route path="/admin/create-bill" element={<CreateBill />} />
          <Route path="/admin/create-user" element={<CreateUser />} />
          <Route path="/admin/booking-history" element={<AdminBookingHistory />} />
          <Route path="/admin/billing-report-history" element={<BillingReportHistory />} />
          <Route path="/admin/upload-lab-report" element={<UploadLabReport />} />
          <Route path="/user/profile" element={<UserProfile />} />
          <Route path="/user/doctors" element={<ListOfDoctors />} />
          <Route path="/user/book-appointment" element={<BookAppointment />} />
          <Route path="/user/booking-history" element={<UserBookingHistory />} />
          <Route path="/user/billing-history" element={<UserBillingHistory />} />
          <Route path="/user/lab-report-history" element={<LabReportHistory />} />
          <Route path="/admin/settings" element={<Settings />} />
          <Route path="/admin/create-booking" element={<CreateBooking />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
